import type {
  AiTrace,
  ConversationDetail,
  ConversationListItem,
  MessageItem,
  SendMessageInput,
} from '@qualibot/shared';
import { api } from './api-client';

export async function listConversations(): Promise<ConversationListItem[]> {
  const { data } = await api.get<{ items: ConversationListItem[] }>('/api/conversations');
  return data.items;
}

export async function getConversation(id: string): Promise<ConversationDetail> {
  const { data } = await api.get<ConversationDetail>(`/api/conversations/${id}`);
  return data;
}

export async function getConversationTrace(conversationId: string): Promise<AiTrace> {
  const { data } = await api.get<AiTrace>(`/api/conversations/${conversationId}/trace`);
  return data;
}

export async function listMessages(conversationId: string): Promise<MessageItem[]> {
  const { data } = await api.get<{ items: MessageItem[] }>(
    `/api/conversations/${conversationId}/messages`,
  );
  return data.items;
}

export async function sendConversationMessage(
  conversationId: string,
  input: SendMessageInput,
): Promise<MessageItem> {
  const { data } = await api.post<MessageItem>(
    `/api/conversations/${conversationId}/messages`,
    input,
  );
  return data;
}

export async function takeOverConversation(
  conversationId: string,
): Promise<ConversationDetail> {
  const { data } = await api.post<ConversationDetail>(
    `/api/conversations/${conversationId}/takeover`,
  );
  return data;
}

export async function setConversationBot(
  conversationId: string,
  enabled: boolean,
): Promise<ConversationDetail> {
  const { data } = await api.post<ConversationDetail>(
    `/api/conversations/${conversationId}/bot`,
    { enabled },
  );
  return data;
}
